//JS for the pathways-finder and pathways-finder-results pages

var PATHWAYS_SORT_ORDER_COURSE_NAME_ASC  = "AZ";
var PATHWAYS_SORT_ORDER_COURSE_NAME_DESC = "ZA";
var PATHWAYS_SORT_ORDER_ATAR_ASC         = "ATAR_asc";
var PATHWAYS_SORT_ORDER_ATAR_DESC        = "ATAR_desc";

var selected_pathways_finder_value  = "";
var pathways_finder_present         = false;
var pathways_finder_results_present = false;
var pathways_results_page_size      = 18;
var pathways_results_total_pages    = 1;

var search_filters = { studyArea: "all", atarMin: 0, atarMax: -1 };
var sorting_method = "suggested";

var pathways_courses_data = [];

// Read showPathwaysOptions from the JSON config block written by results-item.html
var pathways_config = (function () {
    var el = document.getElementById("pathways-finder-config");
    if (el) {
        try { return JSON.parse(el.textContent); } catch (e) {}
    }
    return {};
})();
var show_pathways_options = pathways_config.showPathwaysOptions === true;

$(document).ready(function () {
    checkForPathwaysComponents();

    if(pathways_finder_present) {
        $(".pathways-finder-search-button").on("click", function (e) {
            e.preventDefault();
            var button_clicked = $(this);
            var button_href    = button_clicked.prop("href");

            if(button_clicked.hasClass("target_other")) {
                var separator = button_href.indexOf("?") !== -1 ? "&" : "?";
                window.location = button_href + separator + "q=" + selected_pathways_finder_value;
            } else {
                if (pathways_finder_results_present) {
                    updateResults();
                }
            }
        });

        $(".pathways-finder__select").change(function () {
            setStudyAreaFromDropdown($(this));
            if (pathways_finder_results_present) {
                updateResults();
            }
        });

        autoSelectDropdownFromQueryString();
    }

    if(pathways_finder_results_present) {
        updateResults();

        $(".pathways-finder-results__view-selector .view_dropdown").change(function () {
            sorting_method = $(this).find("option:selected").val();
            updateResults();
        });

        $(".pathways-finder-results__atar-filter-item_sub").on("click", function (e) {
            e.preventDefault();
            var selected_class   = "pathways-finder-results__atar-filter-item_sub--selected";
            var all_atar_buttons = $(".pathways-finder-results__atar-filter-item_sub");
            var button_clicked   = $(this);

            if (button_clicked.hasClass(selected_class)) {
                button_clicked.removeClass(selected_class);
            } else {
                all_atar_buttons.removeClass(selected_class);
                button_clicked.addClass(selected_class);
            }
            updateSearchFilters();
            updateResults();
        });
    }
});

function checkForPathwaysComponents() {
    if($(".pathways-finder").length > 0) {
        pathways_finder_present = true;
    }
    if($(".pathways-finder-results").length > 0) {
        pathways_finder_results_present = true;
    }
}

// Borrowed from Sajari because it works
var get_hash_value = function (e) {
    var t = new RegExp("[?&]" + e.replace(/[\[\]]/g, "\\$&") + "(=([^&#]*)|&|#|$)"),
        a = t.exec(window.location.href);
    return a && a[2] ? decodeURIComponent(a[2].replace(/\+/g, " ")) : "";
};

function autoSelectDropdownFromQueryString() {
    var q = get_hash_value("q");
    var pathways_finder_select = $(".pathways-finder__select").first();
    var valid_study_area = false;

    if (q && q.length > 0) {
        pathways_finder_select.find("option").each(function () {
            if ($(this).val() === q) {
                valid_study_area = true;
                return false;
            }
        });
        if(valid_study_area) {
            pathways_finder_select.val(q).prop("selected", true);
        }
    }
    if(pathways_finder_results_present) {
        setStudyAreaFromDropdown(pathways_finder_select);
    }
}

function setStudyAreaFromDropdown(dropdown_element) {
    selected_pathways_finder_value = dropdown_element.find("option:selected").val();
    search_filters.studyArea = selected_pathways_finder_value;
}

function updateSearchFilters() {
    var selected_atar_filter = $(".pathways-finder-results__atar-filter-item_sub--selected");
    if(selected_atar_filter.length > 0) {
        search_filters.atarMin = selected_atar_filter.data("minvalue");
        search_filters.atarMax = selected_atar_filter.data("maxvalue");
    } else {
        search_filters.atarMin = 0;
        search_filters.atarMax = -1;
    }
}

function updateResults() {
    if(pathways_courses_data.length > 0) {
        populateList(sortAndFilterCoursesData(pathways_courses_data));
    } else {
        getCoursesJson();
    }
}

function getCoursesJson() {
    $.ajax({
        method: "GET",
        url: "/flinders-services/courses.json/tagFilters.flinders:course/study_type/undergraduate.tagFilters.flinders:course/availability/domestic.json"
    }).done(function (data) {
        pathways_courses_data = data;
        populateList(sortAndFilterCoursesData(data));
    }).fail(function (jqXHR, textStatus) {
        $("#results_container").html(
            '<div class="pathways-finder-results__error">' +
                "Sorry, we couldn\u2019t load courses right now. Please try again later." +
            "</div>"
        );
        console.error("Pathways courses fetch failed:", textStatus);
    });
}

function populateList(data) {
    var container = $("#results_container")[0];
    container.innerHTML = "";

    var fragment = document.createDocumentFragment();
    data.forEach(function (course) {
        fragment.appendChild(buildCourseRow(course));
    });
    container.appendChild(fragment);

    // Ellipsis on course name links
    var all_name_links = $("#results_container").find(".pathways-finder-results__course-name a");
    all_name_links.prop("title", function () { return $(this).text(); });
    all_name_links.ellipsis({ lines: 1, ellipClass: "pathways-finder-results__ellipsis", responsive: true });

    initPaginator(data.length);
    initSortableHeadings();
}

function buildCourseRow(course) {
    var row = document.createElement("div");
    row.className = "pathways-finder-results__item";

    // SATAC column
    var satacCol = document.createElement("div");
    satacCol.className = "pathways-finder-results__item-column pathways-finder-results__item-column--satac";
    satacCol.innerHTML =
        '<span class="pathways-finder-results__item-label">SATAC</span>' +
        '<div class="pathways-finder-results__satac">' + (course.satacCode || "") + "</div>";

    // Course name column
    var nameCol = document.createElement("div");
    nameCol.className = "pathways-finder-results__item-column pathways-finder-results__item-column--course-name";
    var nameLink = document.createElement("a");
    nameLink.href = course.strLink || course.url || "#";
    nameLink.textContent = course.name || "";
    var nameWrapper = document.createElement("div");
    nameWrapper.className = "pathways-finder-results__course-name";
    nameWrapper.appendChild(nameLink);
    nameCol.appendChild(nameWrapper);

    // Pathways options column (only rendered when dialog property = yes)
    var optionsCol = null;
    if (show_pathways_options) {
        optionsCol = document.createElement("div");
        optionsCol.className = "pathways-finder-results__item-column pathways-finder-results__item-column--options-list";
        if (course.pathwaysOptions && course.pathwaysOptions.length > 0) {
            var optionsLabel = document.createElement("span");
            optionsLabel.className = "pathways-finder-results__item-label";
            optionsLabel.textContent = "Your pathways options";
            var ul = document.createElement("ul");
            ul.className = "pathways-finder-results__options-list";
            course.pathwaysOptions.forEach(function (optionHtml) {
                var li = document.createElement("li");
                li.className = "pathways-finder-results__options-list-item";
                li.innerHTML = optionHtml; // items may contain markup, intentional
                ul.appendChild(li);
            });
            optionsCol.appendChild(optionsLabel);
            optionsCol.appendChild(ul);
        }
    }

    // ATAR / selection rank column
    var atarCol = document.createElement("div");
    atarCol.className = "pathways-finder-results__item-column pathways-finder-results__item-column--atar";

    var atarWrapper = document.createElement("div");
    atarWrapper.className = "pathways-finder-results__atar";
    atarWrapper.appendChild(renderAtarCell(course.atarCutoff));
    atarCol.innerHTML = '<span class="pathways-finder-results__item-label">Selection rank</span>';
    atarCol.appendChild(atarWrapper);

    // Contact column
    var contactCol = document.createElement("div");
    contactCol.className = "pathways-finder-results__item-column pathways-finder-results__item-column--contact";
    contactCol.innerHTML =
        '<div class="pathways-finder-results__icons">' +
            '<a class="enquire_link" title="Enquire" href="' + (course.link || "#") + '#enquiry" target="_blank">' +
                '<i class="fa fa-envelope-o"></i>' +
            "</a>" +
        "</div>";

    row.appendChild(satacCol);
    row.appendChild(nameCol);
    if (optionsCol) { row.appendChild(optionsCol); }
    row.appendChild(atarCol);
    row.appendChild(contactCol);

    return row;
}

function renderAtarCell(atarValue) {
    var div = document.createElement("div");

    if ($.isNumeric(atarValue)) {
        div.textContent = atarValue;
    } else {
        div.className = "pathways-finder-results__atar--small";
        div.textContent = atarValue != null ? atarValue : "";
    }

    return div;
}

function sortAndFilterCoursesData(courses) {
    courses = courses.filter(function (course) {
        var study_area_filter_bool = false;
        var atar_min_filter_bool   = true;
        var atar_max_filter_bool   = true;
        var atar_score_to_compare  = parseFloat(course.atarCutoff);
        var current_course_tags    = course.tags;

        for (var key in search_filters) {
            if (key === "studyArea") {
                var study_area = search_filters[key];
                if (study_area !== "all") {
                    if (jQuery.inArray("flinders:course/study_area/" + study_area, current_course_tags) !== -1) {
                        study_area_filter_bool = true;
                    }
                } else {
                    study_area_filter_bool = true;
                }
            }
            if(key === "atarMin") {
                var current_atar_min_value = parseFloat(search_filters[key]);
                if (current_atar_min_value > 0) {
                    atar_min_filter_bool = atar_score_to_compare >= current_atar_min_value;
                }
            }
            if(key === "atarMax") {
                var current_atar_max_value = search_filters[key];
                if(current_atar_max_value > 0) {
                    atar_max_filter_bool = atar_score_to_compare <= current_atar_max_value;
                }
            }
        }
        return study_area_filter_bool && atar_min_filter_bool && atar_max_filter_bool;
    });

    courses = courses.sort(getSortCompareFunction(sorting_method));
    return courses;
}

function initSortableHeadings() {
    var ORDER_TYPE_COURSE_NAME  = "NAME";
    var ORDER_TYPE_ATAR         = "ATAR";
    var order_selector_dropdown = $(".pathways-finder-results__view-selector .view_dropdown");
    var selected_chevron_class  = "pathways-finder-results__order-direction-chevron--selected";
    var all_heading_chevrons    = $(".pathways-finder-results__order-direction-chevron");

    $(document).off("click.pathways_heading_sort");
    $(document).off("click.pathways_chevron_sort");

    $(".pathways-finder-results__item-heading--orderable").on("click.pathways_heading_sort", function (e) {
        e.preventDefault();
        var order_type = $(this).data("order-type");
        if (order_type === ORDER_TYPE_COURSE_NAME) {
            order_selector_dropdown.val(
                sorting_method === PATHWAYS_SORT_ORDER_COURSE_NAME_ASC
                    ? PATHWAYS_SORT_ORDER_COURSE_NAME_DESC
                    : PATHWAYS_SORT_ORDER_COURSE_NAME_ASC
            ).trigger("change");
        } else if (order_type === ORDER_TYPE_ATAR) {
            order_selector_dropdown.val(
                sorting_method === PATHWAYS_SORT_ORDER_ATAR_ASC
                    ? PATHWAYS_SORT_ORDER_ATAR_DESC
                    : PATHWAYS_SORT_ORDER_ATAR_ASC
            ).trigger("change");
        } else {
            order_selector_dropdown.val("suggested").trigger("change");
        }
    });

    all_heading_chevrons.on("click.pathways_chevron_sort", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!$(this).hasClass(selected_chevron_class)) {
            order_selector_dropdown.val($(this).data("direction")).trigger("change");
        }
    });

    all_heading_chevrons.removeClass(selected_chevron_class);
    if(sorting_method !== "suggested") {
        all_heading_chevrons.filter('[data-direction="' + sorting_method + '"]').addClass(selected_chevron_class);
    }
}

function initPaginator(total_courses) {
    $(".pathways-finder-results__count").show();
    $(".results_count").text(total_courses);

    var pathways_paginator = $(".pathways-finder-results__paginator");
    pathways_results_page_size   = parseInt(pathways_paginator.data("pagesize"));
    pathways_results_total_pages = Math.ceil(total_courses / pathways_results_page_size);

    pathways_paginator.data("totalpages", pathways_results_total_pages);

    $(document).off("click.paginator_prev");
    $(document).off("click.paginator_page");
    $(document).off("click.paginator_next");

    pathways_paginator.empty();
    pathways_paginator[0].appendChild(buildPaginatorDOM(pathways_results_total_pages));

    updateResultsPages("init", 1);

    $(".paginator_prev").on("click.paginator_prev", function (e) {
        e.preventDefault();
        if (!$(this).hasClass("paginator_prev--disabled")) { updateResultsPages("prev", 0); }
    });
    $(".paginator_page").on("click.paginator_page", function (e) {
        e.preventDefault();
        var page_number = $(this).data("pagenumber");
        if (!$(this).hasClass("paginator_page--selected")) { updateResultsPages("jump", page_number); }
    });
    $(".paginator_next").on("click.paginator_next", function (e) {
        e.preventDefault();
        if (!$(this).hasClass("paginator_next--disabled")) { updateResultsPages("next", 0); }
    });
}

function buildPaginatorDOM(totalPages) {
    var fragment = document.createDocumentFragment();

    var prev = document.createElement("a");
    prev.className = "paginator_prev paginator_prev--disabled";
    prev.href = "#";
    prev.title = "Previous";
    prev.innerHTML = '<i class="fa fa-chevron-left"></i>';
    fragment.appendChild(prev);

    for (var i = 1; i <= totalPages; i++) {
        var page = document.createElement("a");
        page.className = "paginator_page" + (i === 1 ? " paginator_page--selected" : "");
        page.setAttribute("data-pagenumber", i);
        page.href = "#";
        page.textContent = i;
        fragment.appendChild(page);
    }

    var next = document.createElement("a");
    next.className = "paginator_next";
    next.href = "#";
    next.title = "Next";
    next.innerHTML = '<i class="fa fa-chevron-right"></i>';
    fragment.appendChild(next);

    return fragment;
}

function updateResultsPages(action, pageNumber) {
    var display_class         = "pathways-finder-results__item--shown";
    var already_selected_page = $(".paginator_page.paginator_page--selected");
    var current_page_number   = already_selected_page.data("pagenumber");

    if (action === "prev") {
        var prev_page = $(".paginator_page[data-pagenumber='" + (current_page_number - 1) + "']");
        already_selected_page.removeClass("paginator_page--selected");
        prev_page.addClass("paginator_page--selected");
        updatePaginatorPrevNextButtons(prev_page.data("pagenumber"));
    } else if (action === "next") {
        var next_page = $(".paginator_page[data-pagenumber='" + (parseInt(current_page_number) + 1) + "']");
        already_selected_page.removeClass("paginator_page--selected");
        next_page.addClass("paginator_page--selected");
        updatePaginatorPrevNextButtons(next_page.data("pagenumber"));
    } else if (action === "jump") {
        var jump_page = $(".paginator_page[data-pagenumber='" + pageNumber + "']");
        already_selected_page.removeClass("paginator_page--selected");
        jump_page.addClass("paginator_page--selected");
        updatePaginatorPrevNextButtons(jump_page.data("pagenumber"));
    } else {
        updatePaginatorPrevNextButtons(1);
    }

    var all_results       = $(".pathways-finder-results__item");
    var new_page_selected = $(".paginator_page.paginator_page--selected").data("pagenumber");
    all_results.removeClass(display_class);
    all_results
        .slice((new_page_selected - 1) * pathways_results_page_size, new_page_selected * pathways_results_page_size)
        .addClass(display_class);

    setupSelectionRankTooltips();
}

function updatePaginatorPrevNextButtons(pageNumber) {
    $(".paginator_prev").toggleClass("paginator_prev--disabled", pageNumber === 1);
    $(".paginator_next").toggleClass("paginator_next--disabled", pageNumber === pathways_results_total_pages);
}

// ─────────────────────────────────────────────────────────────────────────────
// Sort compare functions
// ─────────────────────────────────────────────────────────────────────────────

function getSortCompareFunction(sort_method) {
    switch (sort_method) {
        case PATHWAYS_SORT_ORDER_COURSE_NAME_ASC:
            return function (a, b) {
                var nameA = a.name.toUpperCase(), nameB = b.name.toUpperCase();
                return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
            };
        case PATHWAYS_SORT_ORDER_COURSE_NAME_DESC:
            return function (a, b) {
                var nameA = a.name.toUpperCase(), nameB = b.name.toUpperCase();
                return nameB < nameA ? -1 : nameB > nameA ? 1 : 0;
            };
        case PATHWAYS_SORT_ORDER_ATAR_DESC:
            return function (a, b) {
                return ($.isNumeric(b.atarCutoff) ? b.atarCutoff : 0) - ($.isNumeric(a.atarCutoff) ? a.atarCutoff : 0);
            };
        case PATHWAYS_SORT_ORDER_ATAR_ASC:
            return function (a, b) {
                return ($.isNumeric(a.atarCutoff) ? a.atarCutoff : 0) - ($.isNumeric(b.atarCutoff) ? b.atarCutoff : 0);
            };
        default:
            return function (a, b) {
                var nameA      = a.name.toUpperCase(), nameB = b.name.toUpperCase();
                var a_promoted = a.hasOwnProperty("promoted") ? a.promoted : false;
                var b_promoted = b.hasOwnProperty("promoted") ? b.promoted : false;
                var a_priority = parseInt(a.priority) || 0;
                var b_priority = parseInt(b.priority) || 0;

                if (a_promoted === b_promoted) {
                    if (b_priority !== a_priority) { return b_priority - a_priority; }
                    return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
                }
                return a_promoted ? -1 : 1;
            };
    }
}

// ─────────────────────────────────────────────────────────────────────────────
// Tooltips
// ─────────────────────────────────────────────────────────────────────────────

function setupSelectionRankTooltips() {
    var all_selection_rank_tooltips = $(".atar_tooltip_icon");
    var tooltip_template =
        '<div class="tooltip ff_tooltip" role="tooltip">' +
            '<div class="tooltip-arrow"></div>' +
            '<div class="tooltip-inner"></div>' +
        "</div>";

    all_selection_rank_tooltips.on("click focus", function (e) {
        e.preventDefault();
        return false;
    });
    all_selection_rank_tooltips.tooltip({
        animation: true,
        container: ".fast_facts_tooltip_icon",
        placement: "top",
        trigger:   "click hover focus",
        template:  tooltip_template
    });
}
